import CustomMap from "@components/Map";
import type { Mission } from "@components/Map/type";
import { Box, Grid, Stack, Typography } from "@mui/material";

import CustomCard from "@/components/Delivery/CreateDeliveryDeal/ui/custom-card";
import DestinationArrivalCard from "@/components/Delivery/CreateDeliveryDeal/ui/destination-arrival-card";

import type { DeliveryDealFormApi } from "./hooks/use-delivery-deal-form";
import type { Delivery } from "./types";

type DeliveryScheduleMapSectionProps = {
  delivery: Delivery;
  form: DeliveryDealFormApi;
  missions: Mission[];
};

export function DeliveryScheduleMapSection({
  delivery,
  form,
  missions,
}: DeliveryScheduleMapSectionProps) {
  return (
    <Stack spacing={3}>
      <CustomCard label="Planification des horaires">
        <Grid container spacing={3}>
          <Grid size={{ xs: 4, md: 6 }}>
            <form.AppField name="carAvailabilityDate">
              {(field) => <field.DateTimeField label="Disponibilité du véhicule" />}
            </form.AppField>
          </Grid>

          <Grid size={{ xs: 4, md: 6 }}>
            <form.AppField name="carPickUpDate">
              {(field) => <field.DateTimeField label="Date d'enlèvement" />}
            </form.AppField>
          </Grid>

          <Grid size={{ xs: 4, md: 12 }}>
            <form.AppField name="carDeliveryDeadline">
              {(field) => <field.DateTimeField label="Date limite de livraison" />}
            </form.AppField>
          </Grid>
        </Grid>
      </CustomCard>

      <Box>
        <Box
          sx={{
            height: 400,
            borderRadius: "12px 12px 0 0",
            overflow: "hidden",
            boxShadow: "0 4px 20px rgba(28, 20, 99, 0.18)",
          }}
        >
          <CustomMap data={missions} />
        </Box>
        <Box
          sx={{
            backgroundColor: "white",
            borderRadius: "0 0 12px 12px",
            border: "1px solid",
            borderColor: "grey.200",
            borderTop: "none",
            p: 3,
            mt: 0,
            position: "relative",
            boxShadow: "0 4px 20px rgba(28, 20, 99, 0.18)",
          }}
        >
          <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 2 }}>
            <Box
              sx={{ width: 8, height: 8, borderRadius: "50%", backgroundColor: "primary.main" }}
            />
            <Typography
              variant="body2"
              sx={{
                color: "primary.main",
                fontWeight: 700,
                fontSize: "0.85rem",
                textTransform: "uppercase",
                letterSpacing: 0.5,
              }}
            >
              Itinéraire
            </Typography>
          </Box>
          <DestinationArrivalCard
            origin={delivery.fromAddress?.address ?? ""}
            destination={delivery.toAddress?.address ?? ""}
            contrast="light"
          />
        </Box>
      </Box>
    </Stack>
  );
}
